import { useCallback } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';
import {
  useAnalyticsOrgLocations,
  CompareLocationsButton as SharedCompareLocationsButton,
} from '@frontend/analytics-shared';
import { useIsAppointmentDemoAccount } from '../hooks/use-is-appointment-demo-account';
import { useShowAppointmentAnalyticsV2 } from '../hooks/use-show-updated-appointment-analytics';

export const CompareLocationsButton = () => {
  const showAppointmentAnalyticsV2 = useShowAppointmentAnalyticsV2();
  const navigate = useNavigate();
  const search = useSearch({ from: '/analytics/appointment' });
  const isDemoAccount = useIsAppointmentDemoAccount();

  const { hasAccessToMultipleLocations } = useAnalyticsOrgLocations({
    isDemoAccount,
    module: 'APPOINTMENT',
  });

  const navigateToCompareLocations = useCallback(() => {
    navigate({
      to: '/analytics/appointment',
      search: { ...search, comparingLocations: search.comparingLocations ? undefined : true },
      replace: true,
    });
  }, [search, navigate]);

  // Only show the button if the user has access to multiple locations
  if (!showAppointmentAnalyticsV2 || !hasAccessToMultipleLocations) {
    return null;
  }

  return (
    <SharedCompareLocationsButton
      comparingLocations={!!search.comparingLocations}
      onToggle={navigateToCompareLocations}
      coachmarkKey='air-compare-locations-tooltip'
    />
  );
};
